import { createContext, useContext } from 'react';
export var TabsContext = /*#__PURE__*/createContext({
  variant: "filled"
});
export var TabsProvider = TabsContext.Provider;
export var useTabsContext = function useTabsContext() {
  var context = useContext(TabsContext);

  if (!context) {
    throw new Error("useTabsContext must be used within a TabsContext.Provider");
  }

  return context;
};